<nav class="sg-flex-row sg-justify-between sg-items-center">
  @if (showBurgerMenu) {
    <a class="sg-hide:gt-xs" mat-icon-button (click)="menuButtonClick.emit()"><mat-icon>menu</mat-icon></a>
  }
  @if (logoSrc && _showLogo) {
    <a [href]="homeUrl" class="sg-flex-row sg-logo"><img [src]="logoSrc" /></a>
  }
  <div class="sg-flex-auto">
    @for (el of topNavService.headerItems$ | async; track $index) {
      <ng-container *ngTemplateOutlet="el.templateRef"></ng-container>
    }
  </div>
  <div class="sg-flex-row sg-justify-center sg-items-center sg-main-content-top-nav">
    @for (btn of topNavService.navbarItems$ | async; track $index) {
      <ng-container *ngTemplateOutlet="btn.templateRef"></ng-container>
    }
    @if (!hideActionsMenu) {
      <a mat-icon-button [matMenuTriggerFor]="menu" yPosition="below">
        <mat-icon [ngClass]="{ 'production-icons-color': sgEnv.isAdminProd }">more_vert</mat-icon>
      </a>
    }
    <mat-menu #menu="matMenu">
      @for (btn of topNavService.menuItems$ | async; track $index) {
        @switch (btn.vertMenuType) {
          @case ("element") {
            <ng-container *ngTemplateOutlet="btn.templateRef"></ng-container>
          }
          @case ("menuButton") {
            <button mat-menu-item [matMenuTriggerFor]="btn.menuTriggerFor">
              <ng-container *ngTemplateOutlet="btn.templateRef"></ng-container>
            </button>
          }
          @case ("button") {
            <button mat-menu-item><ng-container *ngTemplateOutlet="btn.templateRef"></ng-container></button>
          }
        }
      }
      @if (sgTranslation.langs.length > 1) {
        <button mat-menu-item [matMenuTriggerFor]="languageMenu">
          <mat-icon>language</mat-icon>
          <span>Language</span>
        </button>
      }
      <button mat-menu-item (click)="logoutClick.emit()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
    <mat-menu #languageMenu="matMenu">
      @for (l of sgTranslation.langs; track $index) {
        <button [disabled]="l.key === sgTranslation.translate.currentLang" mat-menu-item (click)="langClick.emit(l.key)">
          {{ l.localName || l.globalName }}
        </button>
      }
    </mat-menu>
  </div>
</nav>
